import { render } from "./InvitationModal.vue?vue&type=template&id=a8de4c08&scoped=true"
import script from "./InvitationModal.vue?vue&type=script&lang=js"
export * from "./InvitationModal.vue?vue&type=script&lang=js"

import "./InvitationModal.vue?vue&type=style&index=0&id=a8de4c08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8de4c08"]])

export default __exports__